<template>
  <div class="fillcontain" >
    <head-top></head-top>
    <div class="select_container">
      <el-button type="primary" class="el-icon-plus" @click="addFormVisible = true">添加分类</el-button>
    </div>
    <div class="table_container">
      <el-table
        :data="tableData"
        highlight-current-row
        style="width: 100%">
        <el-table-column
          prop="sort"
          label="序号"
          width="100">
        </el-table-column>
        <el-table-column
          property="typeName"
          label="分类名称">
        </el-table-column>
        <el-table-column
          width="100"
          fixed="right"
          label="操作">
          <template slot-scope="scope" >
            <el-button type="text" size="small" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
            <el-button type="text" size="small" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="Pagination">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-size="20"
          layout="total, prev, pager, next"
          :total="total">
        </el-pagination>
      </div>

      <!--&lt;!&ndash;新增排版&ndash;&gt;-->
      <el-dialog title="新增分类"  :visible.sync="addFormVisible" :close-on-click-modal="false" v-loading="loading">
        <el-form :model="addForm" label-width="80px" ref="addForm">
          <el-form-item label="分类名称" prop="name">
            <el-input v-model="addForm.name" auto-complete="off" maxlength="5" ></el-input>
          </el-form-item>
          <el-form-item label="分类排序" prop="name">
            <el-input v-model="addForm.sort" auto-complete="off"  maxlength="5"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="cancel">取消</el-button>
          <el-button type="primary" @click="addSubmit()" >提交</el-button>
        </div>
      </el-dialog>

      <el-dialog title="编辑" :visible.sync="dialogFormVisible" v-loading="loading">
        <el-form :model="form" label-width="80px" ref="addForm">
          <el-form-item label="分类名称">
            <el-input v-model="form.name" autocomplete="off" maxlength="5"></el-input>
          </el-form-item>
          <el-form-item label="分类排序" prop="name">
            <el-input v-model="form.sort" auto-complete="off"  maxlength="5"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogFormVisible = false">取 消</el-button>
          <el-button type="primary" @click="addSubmits()">确 定</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>


<script>
  import headTop from '../components/headTop'
  import { getClassification,getModClassification,getAddClassification,getDelCurriculum } from "../api/api"
  export default {
    data () {
      return {
        tableData: [],
        limit: 20,
        total: 0,
        currentPage: 1,
        addFormVisible: false,
        dialogFormVisible:false,
        addForm:{
          name:'',
          sort:''
        },
        form: {
          name: '',
          sort:''
        },
        loading:false
      }
    },
    components: {
      headTop,
    },
    methods:{
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
      },
      handleCurrentChange(val) {
        this.currentPage = val;
        this.getCurriculum()
      },
      getCurriculum(){
        // 获取课程分类列表数据
        let params={
          category:1,
          pageNum:this.currentPage,
          pageSize:this.limit,
        };
        getClassification(params).then(res=>{
          this.total = res.total
          this.tableData = res.pageInfo
        }).catch(error=>{
          console.log(error);
        })
      },
      //编辑
      handleEdit(index, row) {
        this.dialogFormVisible = true
        this.form.name = row.typeName
        this.form.typeId = row.typeId
        this.form.sort = row.sort
      },
      //修改分类名称
      addSubmits(){
        if (this.form.name == '' || this.form.sort == '' || this.form.sort == '0'){
          this.$message({
            type: 'error',
            message: '请输入正确信息'
          });
        } else {
          this.loading = true
          let params = {
            typeName: this.form.name.replace(/[^A-Za-z0-9\u4e00-\u9fa5]/g,''),
            typeId: this.form.typeId,
            category: 1,
            operationId: JSON.parse(sessionStorage.getItem('user')).id,
            parentId:0,
            sort:this.form.sort
          };
          getModClassification(params).then(res => {
            if (res.state == true) {
              this.$message({
                type: 'success',
                message: res.msg
              });
              this.loading = false
              this.dialogFormVisible = false
              this.getCurriculum()
            } else {
              this.$message({
                type: 'error',
                message: '请输入正确信息'
              });
              this.loading = false
            }
          }).catch(error => {
            this.loading = false
            console.log(error)
          })
        }
      },
      //添加分类
      addSubmit(){
        if (this.addForm.name == ''|| this.addForm.sort == ''  || this.addForm.sort == '0'){
          this.$message({
            type: 'error',
            message: '请输入正确信息'
          });
        } else {
          this.loading = true
          let params={
            typeName:this.addForm.name.replace(/[^A-Za-z0-9\u4e00-\u9fa5]/g,''),
            category:1,
            operationId:JSON.parse(sessionStorage.getItem('user')).id,
            parentId:0,
            sort:this.addForm.sort
          };
          getAddClassification(params).then(res=>{
            if (res.state == true) {
              this.$message({
                type: 'success',
                message: res.msg
              });
              this.loading = false
              this.addFormVisible = false
              this.getCurriculum();
              this.addForm = {}
            }else{
              this.$message({
                type: 'error',
                message: '请输入正确信息'
              });
              this.loading = false
            }
          }).catch(error=>{
            this.loading = false
            console.log(error)
          })
        }
      },
      cancel(){
        this.addForm = {}
        this.addFormVisible = false
      },
      handleDelete(index, row){
        //删除
        this.$confirm('确认删除该记录吗？', '提示', {
          // type: 'warning'
        }).then(() => {
          let params={
            typeId:row.typeId,
            operationId:JSON.parse(sessionStorage.getItem('user')).id,
            category:1,
            parentId:row.parentId,
            sort:row.sort
          };
          getDelCurriculum(params).then(res=>{
            if (res.state == true) {
              this.$message({
                type: 'success',
                message: res.msg
              });
              this.getCurriculum()
              this.tableData.splice(index, 1);
            }else{
              throw new Error(res.message)
            }
          }).catch(error=>{
            this.$message({
              type: 'error',
              message: res.msg
            });
          })
        }).catch(() => {
        })
      }
    },
    created(){
      this.getCurriculum()
    },
  }
</script>

<style lang="less">
  @import '../style/mixin';

</style>



// WEBPACK FOOTER //
// src/page/shopList.vue